export const API_CALL_RES_STATUS = {
  FAILURE: "failure",
  SUCCESS: "success",
  IDLE: "idle",
};
export const API_CALL_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};
export const USER_MENU_BUTTON = {
  LOGOUT: "Logout",
  DASHBOARD: "Dashboard",
  SAVED_POSTS: "Saved posts",
  CREATE_POST: "Create post",
  EDIT_POST: "Edit post",
  PROFILE: "Profile",
  USER_FEEDBACK:"User Feedback"
};
export const NAV_MENU_BUTTON = {
  POSTS: "Posts",
  ABOUT_US: "About us",
  CONTACT: "Contact",
};
